import axios from "axios";
import { baseURL } from "../config/api";

export const checkServerHealth = async (tenantId: string): Promise<boolean> => {
    try {
        const response = await axios.get(
            `${baseURL}/health`,
            {
                timeout: 60000,
                headers: {
                    "X-Tenant-ID": tenantId
                }
            }
        );

        return response.status === 200;
    } catch (error) {
        console.log("Health check failed:", error);
        return false;
    }
}